/* import __COLOCATED_TEMPLATE__ from './power-select-multiple.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();